import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, OnDestroy, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router
  ) { }

  initCanonical() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.updateCanonical());
  }

  private updateCanonical() {
    const path = this.router.url.split('?')[0].split('#')[0].replace("/", '');
    const canonicalUrl = `${environment.KUDOSHUB_SITE_URL}${path}`;

    // Find existing canonical or create one
    let link: HTMLLinkElement =
      this.document.querySelector("link[rel='canonical']") ||
      this.document.createElement('link');

    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalUrl);

    if (!link.parentNode) {
      this.document.head.appendChild(link);
    }
  }
}
